import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M15 4V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 16v-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 9h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 9h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.8 11.8 19 13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 9h0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.8 6.2 19 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3 21 9-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12.2 6.2 11 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Wand";
const Wand = memo(themed(Icon));
export {
  Wand
};
//# sourceMappingURL=wand.js.map
